import ClientStore from './ClientStore';
import memoryStorage from './storage/Memory';

class MemoryStore extends ClientStore {
  constructor() {
    super(memoryStorage);
  }

  push(key: string, value: any) {
    let values = this.get(key);

    if (values) {
      values.push(value);
    } else {
      values = [value];
    }

    this.set(key, values);
  }
}

export default new MemoryStore();
